<ng-container *transloco="let t; read: 'destination'">
  <ng-container [formGroup]="qqcForm" *ngIf="qqcForm">
    <ng-container [ngSwitch]="quoteType$ | async">
      <ng-container *ngSwitchCase="types.SingleTrip">
        <nibtravel-autocomplete
          #autocomplete
          [e2eId]="e2eId.DestinationCountry"
          [hostId]="'destinations'"
          [formControl]="control"
          [options]="options$"
          [label]="t('label')"
          [labelId]="'destination-label'"
          [inputName]="'destination-input'"
          [inputId]="'destination-input'"
          [validations]="validations"
          [isMultipleSelection]="true"
          [isUniqueSelection]="true"
          [noResultHints]="t('no-results-hint')"
          [popularCountrySuggestions]="popularCountrySuggestions"
          placeholder="Enter countries or regions"
        ></nibtravel-autocomplete>
      </ng-container>
      <ng-container *ngSwitchCase="types.MultiTrip">
        <nibtravel-dropdown
          [e2eId]="e2eId.DestinationRegion"
          [hostId]="'destinations'"
          [inputId]="'destination-input'"
          [inputName]="'destination-input'"
          [label]="t('label')"
          [labelId]="'destination-label'"
          [options]="options$"
          [enableDefaultOption]="true"
          [validations]="validations"
          defaultOptionText="Select your region"
          formControlName="destinationCountryCodes"
        ></nibtravel-dropdown>
      </ng-container>
    </ng-container>
    <nibtravel-qqc-country-suggestions
      [nibtravelAutocomplete]="autocomplete"
      #popularCountrySuggestions
      *ngIf="isShowPopularDestinationPicker$ | async"
    >
    </nibtravel-qqc-country-suggestions>

    <div id="qqc-destination-alert" *ngIf="showAustraliaAlert$ | async">
      <nibtravel-alert
        [type]="AlertType.ALERT"
        [title]="t('australia-restricted-alertTitle')"
      >
        <p>
          {{ t('australia-restricted') }}
        </p>
      </nibtravel-alert>
    </div>

    <div id="qqc-destination-alert" *ngIf="showInternationalToDomesticAlert">
      <nibtravel-alert
        [type]="AlertType.WARNING"
        [title]="t('international-alertTitle')"
      >
        <p>
          {{ t('international-alertContent') }}
        </p>
      </nibtravel-alert>
    </div>
  </ng-container>
</ng-container>
